import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "arrow-down-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.7 15.27a.75.75 0 0 0-1.06-1.06l-5.14 5.15V3.17a.75.75 0 1 0-1.5 0v16.2L5.86 14.2a.75.75 0 0 0-1.06 1.06l6.41 6.42a.75.75 0 0 0 1.08 0l6.41-6.42Z" }, null, -1)
  ])))
}
export default { render: render }